export default __webpack_public_path__ + "static/media/Impact-level_documentation.b7ece36c.jpg";